import axios from 'axios'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

const reviewAxiosClient = axios.create({
    baseURL: SERVER_URL,
})

reviewAxiosClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('reviewAccessToken')
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
    }
    if (config.headers) {
        config.headers['Cache-Control'] = 'no-cache'
        config.headers['Pragma'] = 'no-cache'
        config.headers['Expires'] = '0'
    }
    return config
})

reviewAxiosClient.interceptors.response.use(
    response => response,
    error => {
        if (error?.response?.status === 401) {
            localStorage.removeItem('reviewAccessToken')
            localStorage.removeItem('reviewClientName')
        }
        return Promise.reject(error)
    }
)

export default reviewAxiosClient
